export function getEventTags(event) {
    return (event === null || event === void 0 ? void 0 : event.tags) || [];
}
//# sourceMappingURL=getEventTags.js.map